var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WithPagination',{attrs:{"is-loading":_vm.isLoading,"data":_vm.formattedData,"is-raised":_vm.isRaised},scopedSlots:_vm._u([{key:"default",fn:function({ currentPageData }){return [_vm._t("default",null,{"data":currentPageData,"filterChange":_vm.filterChanged,"sortChange":_vm.sortChanged})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }